import styles from "./index.module.scss";
import { Button, Container, Row, Col } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { useState } from "react";
import RadioButton from "../RadioButton";
import { radiosTabs } from "../../constants/variables";
import { modalEdit } from "../../redux/slices/modal.slice";
import { useDispatch } from "react-redux";
import { addChosenStyle } from "../../redux/slices/styles.slice";
import { addChosenTeacher } from "../../redux/slices/teachers.slice";
import { addChosenLevel } from "../../redux/slices/levels.slice";
import ProfileInformation from "../ProfileInformation";

const tabs = {
  Teachers: ["Name", "Style", "Level", "Color"],
  Levels: ["Level", "Color"],
  Styles: ["Style", "Color"],
};

const TeacherRow = ({ item }) => {
  const dispatch = useDispatch();

  const openModal = () => {
    dispatch(addChosenTeacher(item));
    dispatch(modalEdit("Teachers"));
  };

  const getStyles = () => {
    let styles = "";
    for (let i = 0; i < item.teacherAndstyles?.length; i++) {
      if (i + 1 === item.teacherAndstyles.length) {
        styles += `${item.teacherAndstyles[i].style.styleName}`;
        continue;
      }
      styles += `${item.teacherAndstyles[i].style.styleName}, `;
    }
    return styles;
  };

  const getLevels = () => {
    let levels = "";
    for (let i = 0; i < item.teacherAndlevels?.length; i++) {
      if (i + 1 === item.teacherAndlevels.length) {
        levels += `${item.teacherAndlevels[i].level.levelName}`;
        continue;
      }
      levels += `${item.teacherAndlevels[i].level.levelName}, `;
    }
    return levels || "None";
  };

  return (
    <tr onClick={openModal}>
      <td>{item.teacherName}</td>
      <td>{item.teacherAndstyles?.length > 0 ? getStyles() : "None"}</td>
      <td>{getLevels()}</td>
      <td>
        <div className={styles.color}>
          <div style={{ background: item.teacherColor || "#D9D9D9" }} />
        </div>
      </td>
    </tr>
  );
};

const LevelsRow = ({ item }) => {
  const dispatch = useDispatch();
  const openModal = () => {
    dispatch(addChosenLevel(item));
    dispatch(modalEdit("Levels"));
  };
  return (
    <tr onClick={openModal}>
      <td>{item.levelName}</td>
      <td>
        <div className={styles.color}>
          <div style={{ background: item.color }} />
        </div>
      </td>
    </tr>
  );
};

const StylesRow = ({ item }) => {
  const dispatch = useDispatch();
  const openModal = () => {
    dispatch(addChosenStyle(item));
    dispatch(modalEdit("Styles"));
  };

  return (
    <tr onClick={openModal}>
      <td>{item.styleName}</td>
      <td>
        <div className={styles.color}>
          <div style={{ background: item.styleColor || "#D9D9D9" }} />
        </div>
      </td>
    </tr>
  );
};

const selectedRow = {
  Teachers: (item, index) => (
    <TeacherRow item={item} key={`teachersRow-${index}`} />
  ),
  Levels: (item, index) => <LevelsRow item={item} key={`levelsRow-${index}`} />,
  Styles: (item, index) => <StylesRow item={item} key={`stylesRow-${index}`} />,
};

function UserInfoTab({ data }) {
  const [radioValue, setRadioValue] = useState(radiosTabs[0].name);
  const dispatch = useDispatch();

  const openModal = (item) => {
    dispatch(addChosenStyle(item));
    dispatch(modalEdit("Styles"));
  };

  const getTeachers = (item) => {
    let teachers = "";
    for (let i = 0; i < item.teacherAndstyles.length; i++) {
      if (i + 1 === item.teacherAndstyles.length) {
        teachers += `${item.teacherAndstyles[i].teacher.teacherName}`;
        continue;
      }
      teachers += `${item.teacherAndstyles[i].teacher.teacherName}, `;
    }

    return teachers;
  };

  return (
    <Container fluid style={{ marginTop: "20px" }}>
      <Row>
        <Col className="ps-0" sm={12} lg={9}>
          <div className={styles.tableContainer}>
            <div className={styles.additionalHead}>
              {radiosTabs.map((radio, idx) => (
                <RadioButton
                  uniqId={`userInfoTab-${idx}`}
                  key={`radio-${idx}`}
                  onChangeHandle={setRadioValue}
                  size={"md"}
                  activeValue={radioValue}
                  value={radio.value}
                >
                  {radio.name}
                </RadioButton>
              ))}
              <Button
                className={styles.addBtn}
                size="md"
                variant="link"
                onClick={() => {
                  dispatch(modalEdit(radioValue));
                }}
              >
                Add new {radioValue} +
              </Button>
            </div>
            {radioValue !== "Styles" ? (
              <Table className={styles.tableWithTabs} hover striped={false}>
                <thead>
                  <tr>
                    {tabs[radioValue].map((item, index) => {
                      return <th key={`theadKey-${index}`}>{item}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {data[radioValue].map((item, index) => {
                    return selectedRow[radioValue](item, index);
                  })}
                </tbody>
              </Table>
            ) : (
              <div className={styles.cardsContainer}>
                {data[radioValue].map((item, index) => {
                  return (
                    <div
                      key={`stylesList-${index}`}
                      className={styles.card}
                      onClick={() => openModal(item)}
                    >
                      <h4>{item.styleName}</h4>
                      <div
                        className={styles.color}
                        style={{
                          margin: "10px 0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span>Color:</span>
                        <div
                          style={{
                            background: item.styleColor || "#D9D9D9",
                            width: "20px",
                            height: "20px",
                            borderRadius: "100%",
                            display: "inline-block",
                            marginLeft: "10px",
                          }}
                        />
                      </div>
                      <span>Teachers:</span>
                      <span>
                        {item.teacherAndstyles.length > 0
                          ? getTeachers(item)
                          : "None"}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </Col>
        <Col sm={12} lg={3}>
          <ProfileInformation />
        </Col>
      </Row>
    </Container>
  );
}

export default UserInfoTab;
